import * as Yup from "yup";

const rotaValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
});

export default rotaValidator;
